import { Component } from '@angular/core';
import { MyharrellsService } from '../myharrells.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-myharrellsloginprompt',
  standalone: true,
  imports: [],
  templateUrl: './myharrellsloginprompt.component.html',
  styleUrl: './myharrellsloginprompt.component.css'
})
export class MyharrellsloginpromptComponent {

  constructor(public myHarrellsService: MyharrellsService, public router: Router) { }

  CancelLoginModal() {
    this.myHarrellsService.matrixCouseToViewAfterSuccessfulLogin = 0;
    this.CloseLoginModal();
  }

  EnrollForMyHarrells() {
    this.myHarrellsService.matrixCouseToViewAfterSuccessfulLogin = 0;
    this.router.navigate(['/myharrellsaccountsetup']);
    this.CloseLoginModal();
  }

  CloseLoginModal() {
    document.getElementById("loginModal").style.display = "none";
  }

  LoginB4Course() {
    //the desired course to view is alread in this variable from when the login modal opened
    // this.myHarrellsService.matrixCouseToViewAfterSuccessfulLogin = courseSelected.ItemAlias;


    //the login screen will check for this variable and if found will forward the user to this course after login
    this.router.navigateByUrl('/myharrellslogin');
    this.CloseLoginModal();
  }



}
